import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    "data-testid": "modal-title",
    class: "text-xl font-semibold text-gray-900 dark:text-white"
};
const _hoisted_2 = { class: "space-y-4" };
const _hoisted_3 = { class: "space-y-2" };
const _hoisted_4 = { class: "text-base text-gray-900 dark:text-white" };
const _hoisted_5 = { class: "text-sm text-gray-500 dark:text-gray-400" };
const _hoisted_6 = { class: "mt-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg" };
const _hoisted_7 = { class: "text-sm text-gray-700 dark:text-gray-300" };
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Modal, Button, Alert } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ResumeSubscriptionModal',
    props: {
        isOpen: { type: Boolean },
        subscriptionId: {},
        shopperReference: {},
        merchantReference: {},
        isLoading: { type: Boolean, default: false }
    },
    emits: ["close", "confirm"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const isModalOpen = computed({
            get: () => props.isOpen,
            set: () => handleClose(),
        });
        const handleClose = () => {
            if (!props.isLoading) {
                emit("close");
            }
        };
        const handleConfirm = () => {
            if (!props.isLoading) {
                emit("confirm");
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isModalOpen.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isModalOpen).value = $event)),
                size: "sm",
                "data-testid": "resume-subscription-modal",
                dismissable: false,
                "close-on-escape": !__props.isLoading,
                onClose: handleClose
            }, {
                header: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)("dashboard.subscriptions.modal.resume.title")), 1 /* TEXT */)
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "secondary",
                        label: _unref(t)('dashboard.subscriptions.modal.buttons.cancel'),
                        disabled: __props.isLoading,
                        onClick: handleClose
                    }, null, 8 /* PROPS */, ["label", "disabled"]),
                    _createVNode(_unref(Button), {
                        variant: "success",
                        label: _unref(t)('dashboard.subscriptions.actions.resume'),
                        loading: __props.isLoading,
                        onClick: handleConfirm
                    }, null, 8 /* PROPS */, ["label", "loading"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_unref(Alert), {
                            color: "success",
                            heading: _unref(t)('dashboard.subscriptions.modal.resume.warning')
                        }, null, 8 /* PROPS */, ["heading"]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("dashboard.subscriptions.modal.resume.message")), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_5, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("dashboard.subscriptions.modal.resume.merchantReference")), 1 /* TEXT */),
                                _createTextVNode(" " + _toDisplayString(__props.merchantReference), 1 /* TEXT */)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("dashboard.subscriptions.modal.resume.explanation")), 1 /* TEXT */)
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "close-on-escape"]));
        };
    }
});
